import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "./theme.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  progressBar: true,
  newestOnTop: true,
  preventDuplicates: true,
  positionClass: "toast-top-left",

  timeOut: 4500,
  extendedTimeOut: 1500,

  showDuration: 200,
  hideDuration: 200,
  showMethod: "fadeIn",
  hideMethod: "fadeOut",

  tapToDismiss: true,
  escapeHtml: true,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
